import { useState, useEffect, useRef } from 'react';
import Plans from './plans';
import { useNavigate } from 'react-router-dom';
import Footer from '../common/footer';
import Header from '../common/header';
import Landing1 from '../../../assets/images/landing-1.png'
import Landing2 from '../../../assets/images/landing-2.png'

const Home = () => {
  // ===== THEME STATE =====
  const [isDark, setIsDark] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAnnual, setIsAnnual] = useState(false);
  const [activeVideo, setActiveVideo] = useState(0);
  const navigate=useNavigate()

  const videoContainerRef = useRef(null);

  // ===== THEME INITIALIZATION =====
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.documentElement.classList.add('dark');
      setIsDark(true);
    } else {
      document.documentElement.classList.remove('dark');
      setIsDark(false);
    }
  }, []);

  // ===== THEME TOGGLE =====
  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    if (newIsDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  // ===== SYSTEM THEME LISTENER =====
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (!localStorage.getItem('theme')) {
        document.documentElement.classList.remove('dark');
        setIsDark(false);
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // ===== SMOOTH SCROLL =====
  useEffect(() => {
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  // ===== PRICE DATA =====
  const plans = [
    {
      name: 'STANDARD',
      monthly: 1500,
      annual: 16500,
      features: [
        'Gestão de até 100 clientes',
        'Contratos ilimitados',
        'Relatórios básicos',
        'Suporte por email',
      ],
    },
    {
      name: 'PREMIUM',
      monthly: 2500,
      annual: 27500,
      popular: true,
      features: [
        'Tudo do Standard',
        'Gestão de até 500 clientes',
        'Gestão de risco e blacklist',
        'Relatórios avançados',
        'Suporte prioritário',
      ],
    },
    {
      name: 'GOLD',
      monthly: 4000,
      annual: 44000,
      features: [
        'Tudo do Premium',
        'Clientes ilimitados',
        'Gestão de inventário',
        'API de integração',
        'Suporte 24/7',
      ],
    },
  ];

  // ===== VIDEO PLAYLIST DATA =====
  const videos = [
    {
      title: '1. Apresentação do VLMS',
      description: 'Entenda o funcionamento da VLMS.',
      url: 'https://player.vimeo.com/video/1114211416',
      type: 'vimeo',
      disabled: false,
    },
   /* {
      title: '2. Como gerir Contratos',
      description: 'Passo a passo para criar e liquidar um contrato.',
      url: 'https://player.vimeo.com/video/1114211416',
      type: 'vimeo',
      disabled:false,
    },
    {
      title: '3. Fluxo de Caixa Diário',
      description: 'Acompanhe receitas e despesas sem complicação.',
      url: 'https://player.vimeo.com/video/1114211416',
      type: 'vimeo',
      disabled: false,
    },*/
  ];

  // ===== ICONS =====
  const MoonIcon = () => (
    <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" />
  );

  const SunIcon = () => (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="m4.93 4.93 1.41 1.41" />
      <path d="m17.66 17.66 1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="m6.34 17.66-1.41 1.41" />
      <path d="m19.07 4.93-1.41 1.41" />
    </>
  );

  const PlayIcon = ({ size = 18, className = '' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill="currentColor" className={className}>
      <path d="M320-272v-416l320 208-320 208Z" />
    </svg>
  );

  const CheckIcon = ({ className = '' }) => (
    <svg className={`w-3.5 h-3.5 ${className}`} fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
    </svg>
  );

  const XIcon = ({ className = '' }) => (
    <svg className={`w-3.5 h-3.5 ${className}`} fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 011.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  );

  // ===== STYLES =====
  const styles = `
    .fade-up {
      opacity: 0;
      transform: translateY(20px);
      animation: fadeUp 0.6s ease-out forwards;
    }
    @keyframes fadeUp {
      to { opacity: 1; transform: translateY(0); }
    }
    .playlist-item.active {
      background: rgba(37, 99, 235, 0.1);
      border-left: 4px solid #2563eb;
    }
    .playlist-item {
      transition: all 0.2s ease;
      cursor: pointer;
      border-left: 4px solid transparent;
    }
    .playlist-item:hover {
      background: rgba(37, 99, 235, 0.05);
    }
    .dark .playlist-item.active {
      background: rgba(59, 130, 246, 0.15);
      border-left-color: #3b82f6;
    }
    html { scroll-behavior: smooth; }
    .plan-card {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .plan-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
    }
    .dark .plan-card:hover {
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3);
    }
    .feature-item {
      transition: all 0.3s ease;
    }
    .feature-item:hover {
      transform: translateY(-4px);
    }
    details[open] .group-open\\:rotate-180 {
      transform: rotate(180deg);
    }
    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
    .dark ::-webkit-scrollbar-thumb { background: #334155; }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="bg-white dark:bg-gray-950 text-gray-900 dark:text-white transition-colors duration-300 font-sans antialiased">
       
       
        <Header/>

        {/* MAIN CONTENT */}
        <main className="relative w-full min-h-screen bg-white dark:bg-gray-950 transition-colors duration-300 font-sans">
          {/* HERO SECTION */}
          <section id="home" className="relative pt-36 pb-20 px-6 bg-gradient-to-b from-blue-50/50 to-white dark:from-gray-950 dark:to-gray-950 overflow-hidden">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-6 flex flex-col justify-center text-left order-2 lg:order-1">
                  <div className="inline-flex w-fit items-center gap-2 px-4 py-2 rounded-full bg-blue-100/60 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-400 font-semibold text-sm mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse"></span>
                    <span>Sistema Inteligente de Gestão de Microcrédito</span>
                  </div>
                  <h1 className="text-4xl md:text-6xl font-black text-gray-950 dark:text-white tracking-tight leading-[1.15] mb-6">
                    Otimize a gestão da sua <span className="text-blue-700 dark:text-blue-500">Microcrédito</span> com o VLMS.
                  </h1>
                  <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 max-w-xl leading-relaxed">
                     Faça a gestão dos seus clientes, contratos, transações de caixa, pagamentos atrasados, relatórios, operadores, inventário, risco e gestão jurídica de forma eficiente, segura e acessível.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <button onClick={()=>{
                       navigate('/test')
                    }} className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg shadow-blue-700/20 transition-all">
                      Testar grátis
                    </button>
                    <a href="#plans" className="inline-flex items-center justify-center border-2 border-gray-300 dark:border-gray-700 bg-transparent hover:bg-gray-50 dark:hover:bg-gray-900 text-gray-800 dark:text-gray-200 px-8 py-4 rounded-full font-bold text-lg transition-all">
                      Preços & Planos
                    </a>
                  </div>
                </div>
                <div className="lg:col-span-6 order-1 lg:order-2">
                  <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl border-4 border-white dark:border-gray-900 bg-gray-900 aspect-[4/3] flex items-center justify-center">
                    <img src={Landing1} alt="VLMS Dashboard" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ABOUT SHORT */}
          <section className="py-24 px-6 bg-white dark:bg-gray-950">
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-16">
              <div className="flex-1">
                <h3 className="text-4xl font-black text-gray-900 dark:text-white leading-tight mb-4">
                  <span className="text-blue-700 dark:text-blue-500">Otimize</span> as operações da sua Microcrédito
                </h3>
                <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6">Leve seu negócio para o próximo nível</h2>
                <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-8">
                  A plataforma VLMS automatiza tarefas rotineiras e repetitivas, como análise de crédito, emissão de relatórios e acompanhamento de pagamentos, permitindo que gestores economizem tempo e foquem em atividades estratégicas.
                </p>
                <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-all">Cadastrar minha empresa</a>
              </div>
              <div className="flex-1">
                <img src={Landing2} alt="Sobre VLMS" className="rounded-[2.5rem] shadow-2xl w-full object-cover aspect-[4/3]" />
              </div>
            </div>
          </section>

          {/* TOP FEATURES */}
          <section className="py-24 px-6 bg-gray-50 dark:bg-gray-900/30 transition-colors duration-300">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h3 className="text-blue-700 dark:text-blue-500 font-bold uppercase tracking-widest text-sm mb-2">Recursos</h3>
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white">Como elevamos o <span className="text-blue-700 dark:text-blue-500">seu negócio?</span></h2>
              </div>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="bg-white dark:bg-gray-800 p-8 rounded-3xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-xl transition-all">
                  <div className="w-14 h-14 bg-blue-50 dark:bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 text-blue-700 dark:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 -960 960 960" width="28" fill="currentColor"><path d="M80-160v-120h80v-440q0-33 23.5-56.5T240-800h600v80H240v440h240v120H80Zm520 0q-17 0-28.5-11.5T560-200v-400q0-17 11.5-28.5T600-640h240q17 0 28.5 11.5T880-600v400q0 17-11.5 28.5T840-160H600Zm40-120h160v-280H640v280Zm0 0h160-160Z" /></svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Compatibilidade</h3>
                  <p className="text-gray-600 dark:text-gray-400">Plataforma responsiva para todos os tamanhos de dispositivos.</p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-8 rounded-3xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-xl transition-all">
                  <div className="w-14 h-14 bg-blue-50 dark:bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 text-blue-700 dark:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="28" fill="currentColor"><path d="M570-104q-23 23-57 23t-57-23L104-456q-11-11-17.5-26T80-514v-286q0-33 23.5-56.5T160-880h286q17 0 32 6.5t26 17.5l352 353q23 23 23 56.5T856-390L570-104Zm-57-56 286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640ZM160-800Z" /></svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Plano</h3>
                  <p className="text-gray-600 dark:text-gray-400">Oferecemos planos que se ajustam às necessidades do seu negócio, com possibilidade de personalização.</p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-8 rounded-3xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-xl transition-all">
                  <div className="w-14 h-14 bg-blue-50 dark:bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 text-blue-700 dark:text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="28" fill="currentColor"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80ZM364-182l48-110q-42-15-72.5-46.5T292-412l-110 46q23 64 71 112t111 72Zm-72-366q17-42 47.5-73.5T412-668l-46-110q-64 24-112 72t-72 112l110 46Zm188 188q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm116 178q63-24 110.5-71.5T778-364l-110-48q-15 42-46 72.5T550-292l46 110Zm72-368 110-46q-24-63-71.5-110.5T596-778l-46 112q41 15 71 45.5t47 70.5Z" /></svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Suporte</h3>
                  <p className="text-gray-600 dark:text-gray-400">Temos uma equipe dedicada para fornecer suporte personalizado à sua empresa.</p>
                </div>
              </div>
            </div>
          </section>

          {/* DETAILED FEATURES (hidden by default, matching original) */}
          <section id="features" className="py-24 px-6 bg-white dark:bg-gray-950 hidden">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h3 className="text-blue-700 dark:text-blue-500 font-bold uppercase tracking-widest text-sm mb-2">Funcionalidades</h3>
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white">Recursos da plataforma VLMS</h2>
              </div>

              <div className="feature-item grid lg:grid-cols-2 gap-12 items-center mb-24">
                <div className="order-2 lg:order-1">
                  <span className="inline-block text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Tenha uma visão macro do seu negócio</span>
                  <h3 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mb-4">Dashboard</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
                    Tenha uma visão abrangente e em tempo real dos dados mais relevantes do seu negócio como o estado de contratos, pagamentos por vencer, em atraso, assim como o desempenho das suas receitas.
                  </p>
                  <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-bold transition-all">Testar grátis</a>
                </div>
                <div className="order-1 lg:order-2">
                  <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop" alt="Dashboard VLMS" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" />
                </div>
              </div>

              <div className="feature-item grid lg:grid-cols-2 gap-12 items-center mb-24">
                <div className="order-1 lg:order-2">
                  <span className="inline-block text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Acompanhamento completo</span>
                  <h3 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mb-4">Gestão de Contratos</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
                    Acompanhe o status de cada contrato, desde a solicitação até a liquidação final. Crie e gerencie contratos com facilidade, automatize a cobrança de pagamentos e receba notificações sobre vencimentos próximos. Melhore o atendimento ao cliente e economize tempo valioso.
                  </p>
                  <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-bold transition-all">Testar grátis</a>
                </div>
                <div className="order-2 lg:order-1">
                  <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2070&auto=format&fit=crop" alt="Gestão de Contratos" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" />
                </div>
              </div>

              <div className="feature-item grid lg:grid-cols-2 gap-12 items-center mb-24">
                <div className="order-2 lg:order-1">
                  <span className="inline-block text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Controlo facilitado</span>
                  <h3 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mb-4">Gestão de Caixa</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
                    A ferramenta de gestão de caixa da nossa plataforma facilita o controlo de todas as suas transações, incluindo despesas e receitas, permitindo realizar transferências, transações automáticas no desembolso e pagamento de empréstimos.
                  </p>
                  <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-bold transition-all">Testar grátis</a>
                </div>
                <div className="order-1 lg:order-2">
                  <img src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=2070&auto=format&fit=crop" alt="Gestão de Caixa" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" />
                </div>
              </div>

              <div className="feature-item grid lg:grid-cols-2 gap-12 items-center mb-24">
                <div className="order-1 lg:order-2">
                  <span className="inline-block text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Controlo organizado</span>
                  <h3 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mb-4">Gestão de Bens e Garantias</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
                    Com este módulo, é possível registar e monitorar todos os bens apresentados como garantia nas operações de Microcrédito. Associe facilmente cada bem ou garantia a um contrato, acompanhe a sua localização, validade e estado. A nossa plataforma oferece uma visão clara e detalhada dos bens vinculados, ajudando a reduzir o risco de crédito e a garantir maior segurança jurídica para a sua instituição. Tudo de forma simples, organizada e acessível.
                  </p>
                  <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-bold transition-all">Testar grátis</a>
                </div>
                <div className="order-2 lg:order-1">
                  <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=2070&auto=format&fit=crop" alt="Gestão de Bens e Garantias" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" />
                </div>
              </div>

              <div className="feature-item grid lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <span className="inline-block text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-2">Tome decisões seguras</span>
                  <h3 className="text-3xl md:text-4xl font-black text-gray-900 dark:text-white mb-4">Gestão de Risco</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
                    O módulo de gestão de risco da nossa plataforma permite identificar, avaliar e controlar possíveis ameaças nas operações de Microcrédito. Analise o perfil do cliente, histórico de pagamentos e outros factores essenciais para uma decisão segura. Além disso, tenha acesso à lista negra (blacklist) de clientes com histórico negativo, evitando novas concessões de crédito a perfis de alto risco. Tome decisões mais informadas e proteja a sustentabilidade da sua instituição. Uma solução prática para quem quer prevenir em vez de remediar.
                  </p>
                  <a href="#plans" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-bold transition-all">Testar grátis</a>
                </div>
                <div className="order-1 lg:order-2">
                  <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop" alt="Gestão de Risco" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" />
                </div>
              </div>
            </div>
          </section>

          {/* PROBLEM / SOLUTION SECTION */}
          <section className="py-24 px-6 bg-white dark:bg-gray-950" id="reason">
            <div className="max-w-7xl mx-auto">
              <div className="text-center max-w-3xl mx-auto mb-14">
                <span className="text-xs font-bold text-blue-600 dark:text-blue-400 uppercase tracking-widest">O Desafio</span>
                <h2 className="mt-3 text-3xl sm:text-4xl font-black text-gray-900 dark:text-white leading-tight">
                  Gerir uma Microcrédito sem a ferramenta certa custa caro.
                </h2>
                <p className="mt-5 text-gray-600 dark:text-gray-400 text-lg">Processos manuais, dados dispersos e falta de visão em tempo real são os maiores obstáculos ao crescimento.</p>
              </div>

              <div className="grid lg:grid-cols-2 gap-8">
                {/* Problems */}
                <div className="bg-gray-50 dark:bg-gray-900/50 rounded-3xl p-8 border border-gray-200 dark:border-gray-800 shadow-sm">
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 text-xs font-bold uppercase tracking-wider mb-6">
                    <XIcon className="text-red-600 dark:text-red-400" />
                    Sem VLMS
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">Os obstáculos do dia-a-dia</h3>
                  <ul className="space-y-4">
                    {[
                      { title: 'Processos manuais lentos', desc: 'Horas perdidas em folhas de cálculo e papelada.' },
                      { title: 'Falta de visão consolidada', desc: 'Informação dispersa em vários sistemas.' },
                      { title: 'Risco difícil de medir', desc: 'Decisões de crédito sem dados fiáveis.' },
                      { title: 'Cobranças em atraso', desc: 'Dificuldade em acompanhar vencimentos e renegociações.' },
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <div className="w-6 h-6 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <XIcon className="text-red-600 dark:text-red-400" />
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900 dark:text-white text-sm">{item.title}</div>
                          <div className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">{item.desc}</div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Solutions */}
                <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-3xl p-8 border border-blue-500 relative overflow-hidden shadow-xl">
                  <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)' }}></div>
                  <div className="relative">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 backdrop-blur text-white text-xs font-bold uppercase tracking-wider mb-6">
                      <CheckIcon className="text-white" />
                      Com VLMS
                    </div>
                    <h3 className="text-xl font-bold text-white mb-6">A solução integrada</h3>
                    <ul className="space-y-4">
                      {[
                        { title: 'Automação inteligente', desc: 'Tarefas repetitivas executadas automaticamente.' },
                        { title: 'Visão 360° do negócio', desc: 'Dashboard em tempo real com todos os indicadores.' },
                        { title: 'Análise de risco avançada', desc: 'Blacklist, histórico e scoring automático.' },
                        { title: 'Notificações inteligentes', desc: 'Alertas automáticos de vencimentos e cobranças.' },
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <CheckIcon className="text-white" />
                          </div>
                          <div>
                            <div className="font-semibold text-white text-sm">{item.title}</div>
                            <div className="text-sm text-white/80 mt-0.5">{item.desc}</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* TUTORIALS SECTION */}
          <section id="tutorials" className="py-24 px-6 bg-gray-50 dark:bg-gray-900/30">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h3 className="text-blue-700 dark:text-blue-500 font-bold uppercase tracking-widest text-sm mb-2">Na Prática</h3>
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white">Veja como é <span className="text-blue-700 dark:text-blue-500">fácil e intuitivo</span> usar o VLMS</h2>
              </div>
              <div className="grid lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <div className="rounded-3xl overflow-hidden shadow-2xl bg-black aspect-video" ref={videoContainerRef}>
                    {videos[activeVideo].type === 'vimeo' ? (
                      <iframe
                        src={videos[activeVideo].url}
                        className="w-full h-full"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title={videos[activeVideo].title}
                      />
                    ) : (
                      <video
                        className="w-full h-full"
                        controls
                        controlsList="nodownload"
                        preload="metadata"
                        poster="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop"
                      >
                        <source src={videos[activeVideo].url} type="video/mp4" />
                      </video>
                    )}
                  </div>
                </div>
                <div className="lg:col-span-1">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Módulos da Plataforma</h4>
                  <div className="space-y-2">
                    {videos.map((video, index) => (
                      <div
                        key={index}
                        className={`playlist-item p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 ${activeVideo === index ? 'active' : ''} ${video.disabled ? 'opacity-50' : ''}`}
                        onClick={() => !video.disabled && setActiveVideo(index)}
                      >
                        <div className="flex items-center gap-3">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white shrink-0 ${video.disabled ? 'bg-gray-400' : 'bg-blue-600'}`}>
                            <PlayIcon />
                          </div>
                          <div>
                            <div className="font-semibold text-gray-900 dark:text-white">{video.title}</div>
                            <div className="text-sm text-gray-500 dark:text-gray-400">{video.description}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

         <Plans/>

          {/* FAQ SECTION */}
          <section id="faq" className="py-24 px-6 bg-gray-50 dark:bg-gray-900/30">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-16">
                <h3 className="text-blue-700 dark:text-blue-500 font-bold uppercase tracking-widest text-sm mb-2">FAQ</h3>
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white">Perguntas Frequentes</h2>
              </div>
              <div className="space-y-4">
                {[
                 
     {q:'O que é VLMS',a:'VLMS (Visum Loan Management System) é um sistema integrado de gestão de Microcrédito que otimiza a gestão de clientes, contratos, transações de caixa, pagamentos atrasados, relatórios, operadores e mais de forma eficiente, segura e acessível.'},
     {q:'Qual plano é o ideal para minha empresa?',a:`O plano ideal para sua empresa depende das suas necessidades específicas e do estágio atual do seu negócio. Aqui estão algumas diretrizes gerais para ajudá-lo a escolher.\nPlano Grátis: Se está começando e deseja explorar nossa plataforma sem compromisso financeiro, o plano grátis oferece funcionalidades básicas para iniciar.\nPlano Standard: Se sua empresa está em crescimento e precisa de mais recursos, como mais operadores e gestores, o plano Standard é uma ótima opção para expandir suas operações.\nPlano Premium: Se precisa de funcionalidades avançadas, como notificações por email e SMS, personalizações adicionais e um número ilimitado de operadores, o plano Premium oferece uma solução completa para suas necessidades de gestão.`},
     {q:'Como posso começar a usar o sistema?',a:'Para começar a usar o sistema, terá que preencher os dados de pedido de cadastro da sua empresa, escolher um plano e esperar pela confirmação de email onde irá receber as instruções dos proximos passos.'},
     {q: 'É possível controlar o acesso dos utilizadores?', a: 'Sim. Pode criar diferentes perfis de acesso para operadores, com permissões específicas para cada utilizador.'},
     {q: 'Quanto tempo demora para configurar a minha conta?', a: 'Após o preenchimento do formulário de registo e validação da conta, o acesso pode ser concedido em até 24 horas, dependendo da análise.'},
     {q: 'Posso migrar os dados do meu sistema antigo?', a: 'Sim. A nossa equipa pode ajudar na migração dos dados do seu sistema atual para o VLMS.'},

                ].map((item, index) => (
                  <details key={index} className="group bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 transition-all">
                    <summary className="flex items-center justify-between cursor-pointer list-none">
                      <span className="text-lg font-bold text-gray-900 dark:text-white">{item.q}</span>
                      <span className="transition group-open:rotate-180">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </span>
                    </summary>
                    <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">{item.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA SECTION */}
          <section className="py-20 px-6 bg-white dark:bg-gray-950">
            <div className="max-w-5xl mx-auto bg-gradient-to-br from-blue-700 to-blue-500 rounded-[2.5rem] p-10 md:p-16 text-center text-white shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-black opacity-10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
              <div className="relative z-10">
                <h2 className="text-3xl md:text-5xl font-bold mb-6">Pronto para otimizar a sua Microcredito?</h2>
                <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto">Comece hoje a gerir os seus clientes, contratos e riscos de forma mais eficiente. Fale com um dos nossos especialistas.</p>
                <a href="https://wa.me/258697230000" target="_blank" rel="noopener noreferrer" className="inline-block">
                  <button className="px-8 py-4 bg-white text-blue-700 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all">Fale com um especialista</button>
                </a>
              </div>
            </div>
          </section>

          {/* FOOTER */}
         <Footer/>
        </main>

        {/* WHATSAPP FLOATING BUTTON */}
        <a
          href="https://wa.me/258697230000"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-8 right-8 z-[100] bg-green-500 text-white w-[60px] h-[60px] rounded-full shadow-2xl flex items-center justify-center group transition-colors hover:bg-green-600"
        >
          <i className="fab fa-whatsapp text-3xl"></i>
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25"></span>
        </a>
      </div>
    </>
  );
};

export default Home;